"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.set");
require("core-js/modules/es6.array.find-index");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.match");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _bonusSend = require("@/api/activity/bonusSend");
var _memberManagement = require("@/api/member/memberManagement");
var _goods = require("@/api/goods/goods");
var _shopList = require("@/api/shop/shopList");
var _gradeInfo = require("@/api/basic/gradeInfo");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 图片上传组件
var ImageUpload = {
  name: 'ImageUpload',
  props: {
    value: String,
    prefix: String,
    disabled: Boolean,
    uploadType: String // 上传类型：'banner' 或 'share'
  },
  data: function data() {
    return {
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  mounted: function mounted() {
    this.updateFileList();
  },
  watch: {
    value: {
      handler: function handler(newVal) {
        this.updateFileList();
      }
    }
  },
  methods: {
    updateFileList: function updateFileList() {
      var newVal = this.value;
      if (newVal) {
        var displayUrl = newVal;
        // 如果不是完整URL，需要拼接前缀
        if (!newVal.startsWith('http://') && !newVal.startsWith('https://')) {
          var prefix = this.prefix || '';
          var path = newVal.startsWith('/') ? newVal.slice(1) : newVal;
          displayUrl = prefix.endsWith('/') ? prefix + path : prefix + '/' + path;
        }
        this.fileList = [{
          name: 'image',
          url: displayUrl
        }];
      } else {
        this.fileList = [];
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('只能上传一张图片，如需更换请先删除已上传的图片');
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      // 使用相对路径拼接图片前缀
      var url = file.url;
      if (!url) return;

      // 如果是完整URL，直接使用；否则拼接前缀
      if (url.startsWith('http://') || url.startsWith('https://')) {
        this.dialogImageUrl = url;
      } else {
        // 拼接图片前缀
        var prefix = this.prefix || '';
        var path = url.startsWith('/') ? url.slice(1) : url;
        this.dialogImageUrl = prefix.endsWith('/') ? prefix + path : prefix + '/' + path;
      }
      this.dialogVisible = true;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = [];
      this.$emit('input', '');
    },
    handleChange: function handleChange(file, fileList) {
      if (fileList.length > 0) {
        var latestFile = fileList[fileList.length - 1];
        var isValid = this.beforeUpload(latestFile.raw);
        if (isValid) {
          this.fileList = [latestFile];
          this.uploadImage(latestFile.raw);
        } else {
          this.fileList = [];
          this.$emit('input', '');
        }
      } else {
        this.fileList = [];
        this.$emit('input', '');
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB！');
        return false;
      }
      return true;
    },
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var loading, res, url, relativePath, urlObj, matches, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.prev = 1;
              _context.next = 2;
              return (0, _bonusSend.uploadBonusSendImage)(file);
            case 2:
              res = _context.sent;
              loading.close();
              // 兼容不同的返回格式：res.data 或者直接 res
              url = res && res.data || res;
              if (url) {
                // 将完整 URL 转换为相对路径
                relativePath = url;
                if (url.startsWith('http://') || url.startsWith('https://')) {
                  try {
                    urlObj = new URL(url);
                    relativePath = urlObj.pathname;
                  } catch (e) {
                    // 如果 URL 解析失败，尝试手动提取路径
                    matches = url.match(/https?:\/\/[^/]+(.+)/);
                    if (matches && matches[1]) {
                      relativePath = matches[1];
                    }
                  }
                }
                this.fileList = [{
                  name: file.name,
                  url: relativePath
                }];
                this.$emit('input', relativePath);
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败');
                this.fileList = [];
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              loading.close();
              this.$message.error('上传失败：' + _t.message);
              this.fileList = [];
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3]]);
      }));
      function uploadImage(_x) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }()
  },
  render: function render(h) {
    var _this = this;
    var classes = ['image-upload-container'];
    if (this.disabled) {
      classes.push('is-disabled');
    }
    var hasFile = this.fileList.length > 0;
    var fileUrl = hasFile ? this.fileList[0].url : '';

    // 检查父容器的class，确定图片尺寸
    var imageSize = 40; // 默认小尺寸（用于券明细）
    var borderRadius = '4px';

    // 根据 uploadType prop 或父容器 class 来确定尺寸
    // 私域领券的样式（在 PrivateAreaConfigPane.vue 中定义）：
    // banner-upload: 400px × 100px
    // share-upload: 300px × 160px
    // share-icon-upload: 60px × 60px（分享图标小标）
    // rule-bg-upload: 200px × 120px（规则背景）
    // rule-icon-upload: 60px × 60px（规则图标小标）
    // 默认（coupon-image-upload）: 40px × 40px
    var isBannerUpload = this.uploadType === 'banner' || this.$el && this.$el.parentNode && this.$el.parentNode.classList && this.$el.parentNode.classList.contains('banner-upload');
    var isShareUpload = this.uploadType === 'share' || this.$el && this.$el.parentNode && this.$el.parentNode.classList && this.$el.parentNode.classList.contains('share-upload');
    var isShareIconUpload = this.uploadType === 'share-icon' || this.$el && this.$el.parentNode && this.$el.parentNode.classList && this.$el.parentNode.classList.contains('share-icon-upload');
    var isRuleBgUpload = this.uploadType === 'rule-bg' || this.$el && this.$el.parentNode && this.$el.parentNode.classList && this.$el.parentNode.classList.contains('rule-bg-upload');
    var isRuleIconUpload = this.uploadType === 'rule-icon' || this.$el && this.$el.parentNode && this.$el.parentNode.classList && this.$el.parentNode.classList.contains('rule-icon-upload');
    if (isBannerUpload) {
      imageSize = {
        width: 400,
        height: 100
      };
      borderRadius = '6px';
    } else if (isShareUpload) {
      imageSize = {
        width: 300,
        height: 160
      };
      borderRadius = '6px';
    } else if (isShareIconUpload || isRuleIconUpload) {
      imageSize = {
        width: 60,
        height: 60
      };
      borderRadius = '6px';
    } else if (isRuleBgUpload) {
      imageSize = {
        width: 200,
        height: 120
      };
      borderRadius = '6px';
    }

    // 当有文件时，显示图片和自定义按钮；没有文件时显示上传框
    if (hasFile && !this.disabled) {
      var imgWidth = (0, _typeof2.default)(imageSize) === 'object' ? imageSize.width : imageSize;
      var imgHeight = (0, _typeof2.default)(imageSize) === 'object' ? imageSize.height : imageSize;
      return h('div', {
        class: classes,
        style: {
          position: 'relative',
          display: 'inline-block',
          width: (0, _typeof2.default)(imageSize) === 'object' ? imgWidth + 'px' : 'auto',
          height: (0, _typeof2.default)(imageSize) === 'object' ? imgHeight + 'px' : 'auto'
        }
      }, [
      // 图片容器
      h('div', {
        class: 'image-preview-wrapper',
        style: {
          width: imgWidth + 'px',
          height: imgHeight + 'px',
          position: 'relative',
          display: 'inline-block'
        }
      }, [
      // 图片
      h('img', {
        attrs: {
          src: fileUrl
        },
        style: {
          width: imgWidth + 'px',
          height: imgHeight + 'px',
          objectFit: 'cover',
          borderRadius: borderRadius,
          border: '1px solid #e4e7ed',
          cursor: 'pointer',
          display: 'block'
        },
        on: {
          click: this.handlePictureCardPreview.bind(this, {
            url: fileUrl
          })
        }
      }),
      // 右上角删除按钮（固定显示）
      h('div', {
        class: 'image-delete-button',
        style: {
          position: 'absolute',
          top: '0',
          right: '0',
          width: (0, _typeof2.default)(imageSize) === 'object' ? '24px' : '18px',
          height: (0, _typeof2.default)(imageSize) === 'object' ? '24px' : '18px',
          backgroundColor: 'rgba(245, 108, 108, 0.9)',
          borderRadius: "0 ".concat(borderRadius, " 0 0"),
          zIndex: '10',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'backgroundColor 0.2s'
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.handleRemove();
          },
          mouseenter: function mouseenter(e) {
            e.currentTarget.style.backgroundColor = 'rgba(245, 108, 108, 1)';
          },
          mouseleave: function mouseleave(e) {
            e.currentTarget.style.backgroundColor = 'rgba(245, 108, 108, 0.9)';
          }
        }
      }, [h('i', {
        class: 'el-icon-delete',
        style: {
          fontSize: (0, _typeof2.default)(imageSize) === 'object' ? '14px' : '12px',
          color: '#fff'
        }
      })]),
      // 操作按钮层（hover时显示预览按钮）
      h('div', {
        class: 'image-actions',
        style: {
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          borderRadius: borderRadius,
          zIndex: '5',
          display: 'none',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer'
        },
        on: {
          mouseenter: function mouseenter(e) {
            e.currentTarget.style.display = 'flex';
          },
          mouseleave: function mouseleave(e) {
            e.currentTarget.style.display = 'none';
          },
          click: this.handlePictureCardPreview.bind(this, {
            url: fileUrl
          })
        }
      }, [
      // 预览按钮
      h('i', {
        class: 'el-icon-zoom-in',
        style: {
          fontSize: (0, _typeof2.default)(imageSize) === 'object' ? '20px' : '16px',
          color: '#fff',
          cursor: 'pointer'
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.handlePictureCardPreview({
              url: fileUrl
            });
          }
        }
      })])]),
      // 预览对话框
      h('el-dialog', {
        props: {
          visible: this.dialogVisible,
          title: '图片预览',
          center: true
        },
        on: {
          'update:visible': function updateVisible(val) {
            _this.dialogVisible = val;
          }
        }
      }, [h('img', {
        attrs: {
          src: this.dialogImageUrl
        },
        style: {
          width: '100%',
          display: 'block'
        }
      })])]);
    }

    // 没有文件时显示上传框
    return h('div', {
      class: classes,
      attrs: {
        'data-has-file': hasFile ? 'true' : 'false'
      }
    }, [h('el-upload', {
      props: {
        action: '#',
        'list-type': 'picture-card',
        'file-list': this.fileList,
        limit: 1,
        disabled: this.disabled,
        'on-preview': this.handlePictureCardPreview,
        'on-remove': this.handleRemove,
        'on-change': this.handleChange,
        'on-exceed': this.handleExceed,
        'before-upload': this.beforeUpload,
        'auto-upload': false,
        'show-file-list': false
      }
    }, [h('i', {
      class: 'el-icon-plus',
      slot: 'default'
    })]),
    // 预览对话框
    h('el-dialog', {
      props: {
        visible: this.dialogVisible,
        title: '图片预览',
        center: true
      },
      on: {
        'update:visible': function updateVisible(val) {
          _this.dialogVisible = val;
        }
      }
    }, [h('img', {
      attrs: {
        src: this.dialogImageUrl
      },
      style: {
        width: '100%',
        display: 'block'
      }
    })])]);
  }
};
var _default2 = exports.default = {
  name: 'CouponSendConfig',
  components: {
    ImageUpload: ImageUpload
  },
  props: {
    // 编辑时的ID
    id: {
      type: Number,
      default: null
    },
    // 发放类型（1=优惠券 4=套券）
    sendType: {
      type: Number,
      default: 1
    },
    // 允许的送券事件列表，如 [1, 2, 3] 或 [4] 或 [6]
    allowedEvents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 默认的送券事件（如果只有一个允许的事件，则自动使用该事件）
    defaultEvent: {
      type: Number,
      default: null
    },
    // 送券事件是否固定（不可修改）
    eventFixed: {
      type: Boolean,
      default: false
    },
    // 是否显示主题信息Tab
    showThemeTab: {
      type: Boolean,
      default: true
    },
    // 是否显示送券事件选择器（如果只有一个允许的事件，可以隐藏）
    showEventSelector: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      activeTab: 'basic',
      loading: false,
      submitLoading: false,
      imagePrefix: '',
      bonusTypeList: [],
      bonusRuleList: [],
      couponPackagesList: [],
      dateRange: [],
      // 用户级别列表
      userRankOptions: [],
      eventOptions: {
        1: '注册',
        2: '一键领取',
        3: '领券中心',
        4: '私域领券',
        5: '问卷方法',
        6: '下单',
        7: '会员日'
      },
      formData: {
        title: '',
        sendType: 1,
        event: 1,
        userType: 0,
        userRank: '',
        isQwe: 0,
        enabled: 1,
        canShare: 0,
        sendNum: 0,
        startTime: '',
        endTime: '',
        rules: '',
        orderConsume: 0,
        conditionConsume: 0,
        consumeMaxTimes: 1,
        daily: 0,
        orderReal: 1,
        orderScenes: [1, 2, 3],
        goodsIds: [],
        categoryIds: [],
        storeIds: [],
        theme: {
          title: '',
          fgColor: '#98CAC1',
          bgColor: '#1A4D38',
          bannerUrl: '',
          shareTitle: '',
          shareImgUrl: '',
          shareIconUrl: '',
          rules: '',
          ruleUrl: '',
          ruleIconUrl: ''
        }
      },
      userRankList: [],
      selectedGoodsList: [],
      selectedCategoryList: [],
      tempCategoryList: [],
      selectedPackageId: null,
      selectedCouponId: null,
      categoryOptions: [],
      categoryTreeData: [],
      goodsSelectorVisible: false,
      goodsListQuery: {
        keywords: '',
        categories: [],
        goodsType: '',
        status: '1',
        page: 1,
        limit: 10
      },
      goodsListData: [],
      goodsListTotal: 0,
      tempSelectedGoods: [],
      categorySelectorVisible: false,
      storeSelectorVisible: false,
      storeSearchText: '',
      storeTreeData: [],
      storeTreeProps: {
        children: 'children',
        label: 'label'
      },
      storeExpandedKeys: [],
      storeCheckedKeys: [],
      selectedStoreList: [],
      isStoreTreeInitializing: false,
      formRules: {
        title: [{
          required: true,
          message: '请输入活动标题',
          trigger: 'blur'
        }],
        event: [{
          required: true,
          message: '请选择发放事件',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    isEdit: function isEdit() {
      return !!this.id;
    },
    // 可用的送券事件选项（基于allowedEvents）
    availableEventOptions: function availableEventOptions() {
      var _this2 = this;
      var allOptions = [{
        value: 1,
        label: '注册'
      }, {
        value: 2,
        label: '一键领取'
      }, {
        value: 3,
        label: '领券中心'
      }, {
        value: 4,
        label: '私域领券'
      }, {
        value: 5,
        label: '问卷方法'
      }, {
        value: 6,
        label: '下单'
      }, {
        value: 7,
        label: '会员日'
      }];
      return allOptions.filter(function (opt) {
        return _this2.allowedEvents.includes(opt.value);
      });
    },
    showUserType: function showUserType() {
      return [2, 3, 4, 5, 6, 7].includes(this.formData.event);
    },
    // 是否显示最次数（注册、领券中心时隐藏；一键领取、会员日、下单(下单就送)时显示）
    showMaxTimes: function showMaxTimes() {
      // 一键领取、会员日时显示
      if (this.formData.event === 2 || this.formData.event === 7) return true;
      // 下单场景且为"下单就送"时显示
      if (this.formData.event === 6 && this.formData.orderConsume === 0) return true;
      return false;
    },
    // 最次数标题（根据 daily 的值动态显示）
    maxTimesLabel: function maxTimesLabel() {
      return this.formData.daily === 1 ? '每日最多' : '活动最多';
    },
    // 最大次数说明（根据 daily 的值动态显示）
    maxTimesDescription: function maxTimesDescription() {
      return this.formData.daily === 1 ? '次(每人每日最多)' : '次(每人活动最多)';
    },
    isAllStoresSelected: function isAllStoresSelected() {
      if (!this.storeTreeData || this.storeTreeData.length === 0) {
        return false;
      }
      var _getAllLeafCount = function getAllLeafCount(nodes) {
        var count = 0;
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            count += _getAllLeafCount(node.children);
          } else {
            count++;
          }
        });
        return count;
      };
      var totalLeafCount = _getAllLeafCount(this.storeTreeData);
      return this.storeCheckedKeys.length >= totalLeafCount && totalLeafCount > 0;
    },
    isAllOrderScenesSelected: function isAllOrderScenesSelected() {
      return this.formData.orderScenes.length === 3;
    },
    isAllUserRanksSelected: function isAllUserRanksSelected() {
      var _this3 = this;
      if (!this.userRankOptions || this.userRankOptions.length === 0) return false;
      return this.userRankOptions.length > 0 && this.userRankOptions.every(function (rank) {
        return _this3.userRankList.includes(rank.id);
      });
    },
    selectedPackage: function selectedPackage() {
      var _this4 = this;
      if (!this.selectedPackageId) return null;
      return this.couponPackagesList.find(function (pkg) {
        return pkg.id === _this4.selectedPackageId;
      }) || null;
    },
    // 券明细展示列表：单品券只展示所选的券，套券展示券包全部明细
    displayItems: function displayItems() {
      if (!this.selectedPackage || !this.selectedPackage.items) return [];
      if (this.formData.sendType === 1) {
        return this.selectedPackage.items.filter(function (item) {
          return item.checked;
        });
      }
      return this.selectedPackage.items;
    },
    // 单品券可选优惠券：从启用券包明细中提取并按crmCouponId去重（优先只有一张券的券包）
    singleCouponOptions: function singleCouponOptions() {
      var map = new Map();
      var _iterator = _createForOfIteratorHelper(this.couponPackagesList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pkg = _step.value;
          if (!pkg.items || pkg.items.length === 0) continue;
          var preferred = pkg.items.length === 1;
          var _iterator2 = _createForOfIteratorHelper(pkg.items),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              if (item.crmCouponId == null) continue;
              var key = String(item.crmCouponId);
              var exists = map.get(key);
              if (!exists || preferred && !exists.preferred) {
                map.set(key, {
                  key: key,
                  crmCouponId: item.crmCouponId,
                  couponTitle: item.couponTitle,
                  couponAlias: item.couponAlias,
                  packageId: pkg.id,
                  itemId: item.id,
                  preferred: preferred
                });
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return Array.from(map.values());
    },
    // 券明细原价合计（原价 × 发券数量之和）
    totalOldPrice: function totalOldPrice() {
      if (!this.selectedPackage || !this.selectedPackage.items) return 0;
      return this.selectedPackage.items.filter(function (item) {
        return item.checked;
      }).reduce(function (sum, item) {
        var unit = parseFloat(item.oldPrice != null ? item.oldPrice : item.money) || 0;
        return sum + unit * (item.sendNum || 1);
      }, 0);
    },
    // 是否显示主题信息Tab（在私域领券或领券中心时显示）
    shouldShowThemeTab: function shouldShowThemeTab() {
      return this.showThemeTab && (this.formData.event === 4 || this.formData.event === 3);
    }
  },
  watch: {
    storeSearchText: function storeSearchText(val) {
      this.$refs.storeTreeDialog.filter(val);
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (this.id) {
              this.loading = true;
            }
            _context2.prev = 1;
            _context2.next = 2;
            return this.getImagePrefix();
          case 2:
            _context2.next = 3;
            return this.loadCouponPackages();
          case 3:
            _context2.next = 4;
            return this.loadCategoryTree();
          case 4:
            _context2.next = 5;
            return this.loadStoreTreeData();
          case 5:
            _context2.next = 6;
            return this.loadUserRankList();
          case 6:
            this.initFormData();
            if (!this.id) {
              _context2.next = 7;
              break;
            }
            _context2.next = 7;
            return this.loadFormData();
          case 7:
            _context2.prev = 7;
            if (this.id) {
              this.loading = false;
            }
            return _context2.finish(7);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this, [[1,, 7, 8]]);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    handleSendTypeChange: function handleSendTypeChange(val) {
      this.formData.sendType = val;
      this.selectedPackageId = null;
      this.selectedCouponId = null;
    },
    handleEventChange: function handleEventChange(val) {
      if (val === 1) {
        this.formData.userType = 0;
        this.formData.isQwe = 0;
      } else if (val === 2 || val === 3 || val === 4 || val === 5 || val === 6 || val === 7) {
        if (this.formData.userType === undefined || this.formData.userType === null) {
          this.formData.userType = 0;
        }
        if (this.formData.isQwe === undefined || this.formData.isQwe === null) {
          this.formData.isQwe = 0;
        }
      }
    },
    initFormData: function initFormData() {
      this.formData.title = '';
      this.formData.rules = '';
      this.formData.orderConsume = 0;
      this.formData.conditionConsume = 0;
      this.formData.consumeMaxTimes = 1;
      this.formData.daily = 0;
      this.formData.orderReal = 1;
      this.formData.orderScenes = [1, 2, 3];
      this.formData.goodsIds = [];
      this.formData.categoryIds = [];
      this.formData.storeIds = [];
      this.formData.enabled = 1;
      this.formData.canShare = 0;
      this.formData.userType = 0;
      this.formData.userRank = '';
      this.formData.isQwe = 0;
      this.formData.startTime = '';
      this.formData.endTime = '';
      // 设置默认的送券事件
      if (this.defaultEvent) {
        this.formData.event = this.defaultEvent;
      } else if (this.allowedEvents.length === 1) {
        this.formData.event = this.allowedEvents[0];
      } else {
        this.formData.event = 1;
      }
      this.formData.theme = {
        title: '',
        fgColor: '#98CAC1',
        bgColor: '#1A4D38',
        bannerUrl: '',
        shareTitle: '',
        shareImgUrl: '',
        shareIconUrl: '',
        rules: '',
        ruleUrl: '',
        ruleIconUrl: ''
      };
      this.userRankList = this.userRankOptions.map(function (rank) {
        return rank.id;
      });
      this.selectedGoodsList = [];
      this.selectedCategoryList = [];
      this.selectedStoreList = [];
      this.storeCheckedKeys = [];
      this.selectedPackageId = null;
      this.selectedCouponId = null;
    },
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context3.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t2 = _context3["catch"](0);
              console.error('获取图片前缀失败:', _t2);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    loadCouponPackages: function () {
      var _loadCouponPackages = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _bonusSend.getCouponPackagesWithItems)();
            case 1:
              response = _context4.sent;
              if (response.code === 200 && response.data) {
                this.couponPackagesList = response.data;
              } else {
                this.$message.error(response.message || '加载券包数据失败');
              }
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t3 = _context4["catch"](0);
              console.error('加载券包数据失败:', _t3);
              this.$message.error('加载券包数据失败：' + _t3.message);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function loadCouponPackages() {
        return _loadCouponPackages.apply(this, arguments);
      }
      return loadCouponPackages;
    }(),
    loadFormData: function () {
      var _loadFormData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this5 = this;
        var response, data, themeData, bonusData, matchedPackage, savedItems, checkedItems, opt, storeIds, _t4;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return (0, _bonusSend.getBonusSendDetail)(this.id);
            case 1:
              response = _context5.sent;
              if (response.code === 200 && response.data) {
                data = response.data;
                if (typeof data.theme === 'string') {
                  try {
                    data.theme = JSON.parse(data.theme);
                  } catch (e) {
                    data.theme = this.formData.theme;
                  }
                }
                if (!data.theme || (0, _typeof2.default)(data.theme) !== 'object') {
                  data.theme = {};
                }
                themeData = {
                  title: data.theme.title || '',
                  fgColor: data.theme.fgColor || '#98CAC1',
                  bgColor: data.theme.bgColor || '#1A4D38',
                  bannerUrl: data.theme.bannerUrl || '',
                  shareTitle: data.theme.shareTitle || '',
                  shareImgUrl: data.theme.shareImgUrl || '',
                  shareIconUrl: data.theme.shareIconUrl || '',
                  rules: data.theme.rules || '',
                  ruleUrl: data.theme.ruleUrl || '',
                  ruleIconUrl: data.theme.ruleIconUrl || ''
                };
                data.theme = themeData;
                if (data.startTime && data.endTime) {
                  this.dateRange = [data.startTime, data.endTime];
                }
                if (data.bonus) {
                  bonusData = null;
                  if (typeof data.bonus === 'string') {
                    try {
                      bonusData = JSON.parse(data.bonus);
                    } catch (e) {
                      console.error('解析bonus JSON失败:', e);
                    }
                  } else if ((0, _typeof2.default)(data.bonus) === 'object') {
                    bonusData = data.bonus;
                  }
                  if (bonusData && bonusData.id) {
                    matchedPackage = this.couponPackagesList.find(function (pkg) {
                      return pkg.id === bonusData.id;
                    });
                    if (matchedPackage) {
                      this.selectedPackageId = matchedPackage.id;
                      if (matchedPackage.items && matchedPackage.items.length > 0) {
                        matchedPackage.items.forEach(function (item) {
                          var bonusDetail = bonusData.detail && bonusData.detail.find(function (d) {
                            return d.id === item.id;
                          });
                          console.log('bonusDetail111', bonusDetail);
                          _this5.$set(item, 'checked', !!bonusDetail);
                          // this.$set(item, 'sendNum', bonusDetail ? (bonusDetail.sendNum || 1) : 1)
                          // 编辑模式：永远使用用户保存的值（券图片、每日最多、总共最多）
                          // 如果bonusDetail存在，使用保存的值；否则使用默认值
                          if (bonusDetail) {
                            _this5.$set(item, 'dailyInv', bonusDetail.dailyInv || 0);
                            _this5.$set(item, 'totalNum', bonusDetail.totalNum || 0);
                            _this5.$set(item, 'couponImgUrl', bonusDetail.couponImgUrl || '');
                            // 编辑模式：已保存的值作为下限，只能增加不能减少
                            _this5.$set(item, 'savedDailyInv', bonusDetail.dailyInv || 0);
                            _this5.$set(item, 'savedTotalNum', bonusDetail.totalNum || 0);
                          } else {
                            // 如果没有保存的值，使用默认值
                            _this5.$set(item, 'dailyInv', 0);
                            _this5.$set(item, 'totalNum', 0);
                            _this5.$set(item, 'couponImgUrl', '');
                          }
                          if (bonusDetail && bonusDetail.time) {
                            var times = bonusDetail.time.split('-');
                            if (times.length === 2) {
                              _this5.$set(item, 'timeRange', times);
                            } else {
                              _this5.$set(item, 'timeRange', ['00:00', '23:59']);
                            }
                          } else {
                            _this5.$set(item, 'timeRange', ['00:00', '23:59']);
                          }
                        });
                      }

                      // 单品券（只勾选了部分券）时回显优惠券下拉
                      savedItems = matchedPackage.items || [];
                      checkedItems = savedItems.filter(function (it) {
                        return it.checked;
                      });
                      if (checkedItems.length > 0 && checkedItems.length < savedItems.length) {
                        opt = this.singleCouponOptions.find(function (o) {
                          return String(o.crmCouponId) === String(checkedItems[0].crmCouponId);
                        });
                        if (opt) {
                          this.selectedCouponId = opt.key;
                        }
                      }
                    }
                  }
                }
                if (data.orderScenes) {
                  try {
                    data.orderScenes = typeof data.orderScenes === 'string' ? JSON.parse(data.orderScenes) : data.orderScenes;
                    if (!Array.isArray(data.orderScenes)) {
                      data.orderScenes = [];
                    }
                  } catch (e) {
                    data.orderScenes = [];
                  }
                }
                if (data.goodsIds) {
                  try {
                    data.goodsIds = typeof data.goodsIds === 'string' ? JSON.parse(data.goodsIds) : data.goodsIds;
                    if (!Array.isArray(data.goodsIds)) {
                      data.goodsIds = [];
                    }
                    if (data.goodsIds && data.goodsIds.length > 0) {
                      this.$nextTick(function () {
                        _this5.loadGoodsByIds(data.goodsIds);
                      });
                    }
                  } catch (e) {
                    data.goodsIds = [];
                  }
                }
                if (data.categoryIds) {
                  try {
                    data.categoryIds = typeof data.categoryIds === 'string' ? JSON.parse(data.categoryIds) : data.categoryIds;
                    if (!Array.isArray(data.categoryIds)) {
                      data.categoryIds = [];
                    }
                  } catch (e) {
                    data.categoryIds = [];
                  }
                }
                if (data.storeIds) {
                  try {
                    data.storeIds = typeof data.storeIds === 'string' ? JSON.parse(data.storeIds) : data.storeIds;
                    if (!Array.isArray(data.storeIds)) {
                      data.storeIds = [];
                    }
                  } catch (e) {
                    console.error('解析门店ID列表失败:', e);
                    data.storeIds = [];
                  }
                }
                storeIds = data.storeIds;
                delete data.storeIds;
                this.formData = _objectSpread(_objectSpread({}, this.formData), data);

                // 确保 enabled 有默认值
                if (this.formData.enabled === null || this.formData.enabled === undefined) {
                  this.formData.enabled = 1;
                }

                // 确保 canShare 有默认值
                if (this.formData.canShare === null || this.formData.canShare === undefined) {
                  this.formData.canShare = 0;
                }
                if (data.amount !== undefined && data.amount !== null) {
                  this.formData.conditionConsume = data.amount;
                }
                if (data.userRank) {
                  if (typeof data.userRank === 'string') {
                    this.userRankList = data.userRank.split(',').map(function (item) {
                      return parseInt(item.trim());
                    }).filter(function (num) {
                      return !isNaN(num);
                    });
                  } else if (Array.isArray(data.userRank)) {
                    this.userRankList = data.userRank;
                  }
                } else {
                  this.userRankList = this.userRankOptions.map(function (rank) {
                    return rank.id;
                  });
                }
                if (typeof this.formData.isQwe === 'undefined' || this.formData.isQwe === null) {
                  this.formData.isQwe = 0;
                }
                if (storeIds && Array.isArray(storeIds) && storeIds.length > 0) {
                  this.storeCheckedKeys = storeIds;
                  this.$nextTick(function () {
                    if (_this5.storeTreeData && _this5.storeTreeData.length > 0) {
                      _this5.loadSelectedStoreInfo();
                    }
                  });
                } else {
                  this.storeCheckedKeys = [];
                  this.selectedStoreList = [];
                }
                if (data.categoryIds && Array.isArray(data.categoryIds)) {
                  this.selectedCategoryList = data.categoryIds;
                } else {
                  this.selectedCategoryList = [];
                }
              } else {
                this.$message.error(response.message || '获取详情失败');
              }
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t4 = _context5["catch"](0);
              this.$message.error('获取详情失败：' + _t4.message);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function loadFormData() {
        return _loadFormData.apply(this, arguments);
      }
      return loadFormData;
    }(),
    handleDateChange: function handleDateChange(val) {
      if (val && val.length === 2) {
        this.formData.startTime = val[0];
        this.formData.endTime = val[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }
    },
    openGoodsSelector: function openGoodsSelector() {
      this.goodsSelectorVisible = true;
      this.queryGoodsList();
    },
    queryGoodsList: function () {
      var _queryGoodsList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var loading, params, response, _t5;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context6.prev = 1;
              params = {
                page: this.goodsListQuery.page,
                limit: this.goodsListQuery.limit,
                keywords: this.goodsListQuery.keywords,
                goodsType: this.goodsListQuery.goodsType,
                status: this.goodsListQuery.status
              };
              if (this.goodsListQuery.categories && this.goodsListQuery.categories.length > 0) {
                params.categoryFirstId = this.goodsListQuery.categories[0];
                params.categorySecondId = this.goodsListQuery.categories[1] || null;
              }
              _context6.next = 2;
              return (0, _goods.queryList)(params);
            case 2:
              response = _context6.sent;
              loading.close();
              if (response) {
                this.goodsListData = response.records || [];
                this.goodsListTotal = response.total || 0;
              } else {
                this.$message.error('获取商品列表失败');
              }
              _context6.next = 4;
              break;
            case 3:
              _context6.prev = 3;
              _t5 = _context6["catch"](1);
              loading.close();
              this.$message.error('获取商品列表失败：' + _t5.message);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 3]]);
      }));
      function queryGoodsList() {
        return _queryGoodsList.apply(this, arguments);
      }
      return queryGoodsList;
    }(),
    handleGoodsPageChange: function handleGoodsPageChange(page) {
      this.goodsListQuery.page = page;
      this.queryGoodsList();
    },
    checkGoodsSelectable: function checkGoodsSelectable(row) {
      return !this.selectedGoodsList.some(function (item) {
        return item.goodsCode === row.goodsCode;
      });
    },
    handleGoodsSelectionChange: function handleGoodsSelectionChange(selection) {
      this.tempSelectedGoods = selection;
    },
    confirmGoodsSelection: function confirmGoodsSelection() {
      var _this6 = this;
      if (this.tempSelectedGoods && this.tempSelectedGoods.length > 0) {
        this.tempSelectedGoods.forEach(function (goods) {
          if (!_this6.selectedGoodsList.some(function (item) {
            return item.goodsCode === goods.goodsCode;
          })) {
            _this6.selectedGoodsList.push({
              id: goods.id,
              goodsCode: goods.goodsCode,
              goodsName: goods.goodsName,
              goodsType: goods.goodsType,
              categoryFirstName: goods.categoryFirstName,
              categorySecondName: goods.categorySecondName
            });
          }
        });
      }
      this.goodsSelectorVisible = false;
      this.tempSelectedGoods = [];
    },
    removeGoods: function removeGoods(goodsCode) {
      var index = this.selectedGoodsList.findIndex(function (item) {
        return item.goodsCode === goodsCode;
      });
      if (index > -1) {
        this.selectedGoodsList.splice(index, 1);
      }
    },
    handleClearGoods: function handleClearGoods() {
      var _this7 = this;
      this.$confirm('确认清空所有已选择的商品吗？此操作不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this7.selectedGoodsList = [];
        _this7.$message.success('已清空所有商品');
      }).catch(function () {});
    },
    getGoodsImageUrl: function getGoodsImageUrl(url) {
      if (!url) return '';
      if (url.startsWith('http')) return url;
      return process.env.VUE_APP_BASE_API + url;
    },
    loadGoodsByIds: function () {
      var _loadGoodsByIds = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(goodsIds) {
        var batchSize, allGoods, _loop, i, goodsCodeMap, _t6;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(!goodsIds || goodsIds.length === 0)) {
                _context8.next = 1;
                break;
              }
              this.selectedGoodsList = [];
              return _context8.abrupt("return");
            case 1:
              _context8.prev = 1;
              batchSize = 50;
              allGoods = [];
              _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                var batchIds, response, targetIds, batchGoods;
                return regeneratorRuntime.wrap(function (_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      batchIds = goodsIds.slice(i, i + batchSize).join(',');
                      _context7.next = 1;
                      return (0, _goods.queryList)({
                        goodsIds: batchIds,
                        page: 1,
                        limit: batchSize
                      });
                    case 1:
                      response = _context7.sent;
                      if (response && response.records && Array.isArray(response.records)) {
                        targetIds = new Set(goodsIds.map(function (id) {
                          return String(id);
                        }));
                        batchGoods = response.records.filter(function (item) {
                          return item.goodsCode && targetIds.has(String(item.goodsCode));
                        }).map(function (item) {
                          return {
                            id: Number(item.id),
                            goodsCode: item.goodsCode,
                            goodsName: item.goodsName,
                            goodsType: item.goodsType,
                            categoryFirstName: item.categoryFirstName,
                            categorySecondName: item.categorySecondName
                          };
                        });
                        allGoods.push.apply(allGoods, (0, _toConsumableArray2.default)(batchGoods));
                      }
                    case 2:
                    case "end":
                      return _context7.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 2:
              if (!(i < goodsIds.length)) {
                _context8.next = 4;
                break;
              }
              return _context8.delegateYield(_loop(), "t0", 3);
            case 3:
              i += batchSize;
              _context8.next = 2;
              break;
            case 4:
              goodsCodeMap = new Map(allGoods.map(function (item) {
                return [String(item.goodsCode), item];
              }));
              this.selectedGoodsList = goodsIds.map(function (id) {
                return goodsCodeMap.get(String(id));
              }).filter(function (item) {
                return item !== undefined;
              });
              console.log("\u6210\u529F\u52A0\u8F7D ".concat(this.selectedGoodsList.length, "/").concat(goodsIds.length, " \u4E2A\u5546\u54C1"));
              _context8.next = 6;
              break;
            case 5:
              _context8.prev = 5;
              _t6 = _context8["catch"](1);
              console.error('加载商品信息失败:', _t6);
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee7, this, [[1, 5]]);
      }));
      function loadGoodsByIds(_x2) {
        return _loadGoodsByIds.apply(this, arguments);
      }
      return loadGoodsByIds;
    }(),
    loadCategoryTree: function () {
      var _loadCategoryTree = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var response, treeData, _t7;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 1;
              return (0, _goods.getCategoryTree)();
            case 1:
              response = _context9.sent;
              treeData = null;
              if (response && response.data) {
                treeData = response.data;
              } else if (Array.isArray(response)) {
                treeData = response;
              }
              if (treeData) {
                this.categoryOptions = treeData;
                this.categoryTreeData = this.transformCategoryTree(treeData);
              }
              _context9.next = 3;
              break;
            case 2:
              _context9.prev = 2;
              _t7 = _context9["catch"](0);
              console.error('获取分类树失败:', _t7);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function loadCategoryTree() {
        return _loadCategoryTree.apply(this, arguments);
      }
      return loadCategoryTree;
    }(),
    transformCategoryTree: function transformCategoryTree(nodes) {
      var _this8 = this;
      if (!nodes || !Array.isArray(nodes)) return [];
      return nodes.map(function (node) {
        var newNode = {
          id: node.id,
          categoryName: node.categoryName || node.label || node.categoryName,
          label: node.categoryName || node.label || '未命名分类',
          children: node.children ? _this8.transformCategoryTree(node.children) : []
        };
        return newNode;
      });
    },
    openCategorySelector: function openCategorySelector() {
      var _this9 = this;
      this.categorySelectorVisible = true;
      this.$nextTick(function () {
        var tree = _this9.$refs.categoryTree;
        if (tree) {
          tree.setCheckedKeys(_this9.selectedCategoryList);
        }
      });
    },
    confirmCategorySelection: function confirmCategorySelection() {
      var tree = this.$refs.categoryTree;
      if (tree) {
        var allCheckedKeys = tree.getCheckedKeys();
        var leafCategoryIds = this.getLeafCategoryIds(allCheckedKeys);
        this.selectedCategoryList = leafCategoryIds;
      }
      this.categorySelectorVisible = false;
    },
    getLeafCategoryIds: function getLeafCategoryIds(nodeIds) {
      var leafIds = [];
      var _findLeafIds = function findLeafIds(nodes) {
        if (!nodes || !Array.isArray(nodes)) return;
        nodes.forEach(function (node) {
          if ((!node.children || node.children.length === 0) && nodeIds.includes(node.id)) {
            leafIds.push(node.id);
          }
          if (node.children && node.children.length > 0) {
            _findLeafIds(node.children);
          }
        });
      };
      _findLeafIds(this.categoryOptions);
      return leafIds;
    },
    removeCategory: function removeCategory(categoryId) {
      var index = this.selectedCategoryList.findIndex(function (id) {
        return id === categoryId;
      });
      if (index > -1) {
        this.selectedCategoryList.splice(index, 1);
      }
    },
    handleClearCategories: function handleClearCategories() {
      var _this0 = this;
      this.$confirm('确认清空所有已选择的分类吗？此操作不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this0.selectedCategoryList = [];
        _this0.$message.success('已清空所有分类');
      }).catch(function () {});
    },
    getCategoryName: function getCategoryName(categoryId) {
      var _findCategory = function findCategory(nodes, id) {
        if (!nodes || !Array.isArray(nodes)) return null;
        var _iterator3 = _createForOfIteratorHelper(nodes),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var node = _step3.value;
            if (node.id === id) {
              return node.categoryName || node.label || '未命名分类';
            }
            if (node.children && node.children.length > 0) {
              var found = _findCategory(node.children, id);
              if (found) return found;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        return null;
      };
      return _findCategory(this.categoryTreeData, categoryId) || "\u5206\u7C7B".concat(categoryId);
    },
    toggleAllOrderScenes: function toggleAllOrderScenes() {
      if (this.isAllOrderScenesSelected) {
        this.formData.orderScenes = [];
      } else {
        this.formData.orderScenes = [1, 2, 3];
      }
    },
    selectAllUserRanks: function selectAllUserRanks() {
      if (this.isAllUserRanksSelected) {
        this.userRankList = [];
      } else {
        this.userRankList = this.userRankOptions.map(function (rank) {
          return rank.id;
        });
      }
    },
    handlePackageChange: function handlePackageChange(packageId) {
      var _this1 = this;
      if (!packageId) return;
      var pkg = this.couponPackagesList.find(function (p) {
        return p.id === packageId;
      });
      if (pkg && pkg.items) {
        // 保存当前已输入的值（如果有）
        var currentValues = new Map();
        if (this.selectedPackage && this.selectedPackage.items) {
          this.selectedPackage.items.forEach(function (item) {
            if (item.checked) {
              currentValues.set(item.id, {
                dailyInv: item.dailyInv || 0,
                totalNum: item.totalNum || 0,
                couponImgUrl: item.couponImgUrl || ''
              });
            }
          });
        }
        pkg.items.forEach(function (item) {
          _this1.$set(item, 'checked', true);
          _this1.$set(item, 'sendNum', item.sendNum || 0);
          // 对于已保存的值，优先使用用户输入的；否则使用券包默认值
          var savedValue = currentValues.get(item.id);
          if (savedValue) {
            _this1.$set(item, 'dailyInv', savedValue.dailyInv);
            _this1.$set(item, 'totalNum', savedValue.totalNum);
            _this1.$set(item, 'couponImgUrl', savedValue.couponImgUrl);
          } else {
            _this1.$set(item, 'dailyInv', item.dailyInv || 0);
            _this1.$set(item, 'totalNum', item.totalNum || 0);
            _this1.$set(item, 'couponImgUrl', '');
          }
          _this1.$set(item, 'timeRange', ['00:00', '23:59']);
        });
      }
    },
    handleCouponChange: function handleCouponChange(key) {
      var _this10 = this;
      if (!key) {
        this.selectedPackageId = null;
        return;
      }
      var opt = this.singleCouponOptions.find(function (o) {
        return o.key === key;
      });
      if (!opt) {
        this.selectedCouponId = null;
        this.selectedPackageId = null;
        return;
      }
      var pkg = this.couponPackagesList.find(function (p) {
        return p.id === opt.packageId;
      });
      if (!pkg) {
        this.selectedCouponId = null;
        this.selectedPackageId = null;
        return;
      }
      this.selectedPackageId = pkg.id;
      this.handlePackageChange(pkg.id);
      // 单品券：只勾选所选的那张券
      pkg.items.forEach(function (item) {
        _this10.$set(item, 'checked', item.id === opt.itemId);
      });
    },
    // 编辑模式下每日最多不能低于已保存的值（只能增加不能减少），创建时最小为0
    getDailyInvMin: function getDailyInvMin(item) {
      if (!this.isEdit) return 0;
      return item.savedDailyInv != null ? item.savedDailyInv || 0 : 0;
    },
    // 编辑模式下总共不能低于已保存的值（只能增加不能减少），创建时最小为0
    getTotalNumMin: function getTotalNumMin(item) {
      if (!this.isEdit) return 0;
      return item.savedTotalNum != null ? item.savedTotalNum || 0 : 0;
    },
    getCouponTypeText: function getCouponTypeText(type) {
      var typeMap = {
        1: '代金券',
        2: '折扣券',
        3: '商品券',
        4: '赠品券',
        5: '配送券'
      };
      return typeMap[type] || '未知类型';
    },
    // 格式化价格为两位小数
    formatPrice: function formatPrice(val) {
      var num = parseFloat(val) || 0;
      return num.toFixed(2);
    },
    loadStoreTreeData: function () {
      var _loadStoreTreeData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var response, _t8;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.prev = 0;
              _context0.next = 1;
              return (0, _shopList.queryStore)({});
            case 1:
              response = _context0.sent;
              if (response && response.data) {
                this.storeTreeData = response.data;
                this.storeExpandedKeys = [1, 2];
              }
              _context0.next = 3;
              break;
            case 2:
              _context0.prev = 2;
              _t8 = _context0["catch"](0);
              console.error('获取门店树数据失败:', _t8);
            case 3:
            case "end":
              return _context0.stop();
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function loadStoreTreeData() {
        return _loadStoreTreeData.apply(this, arguments);
      }
      return loadStoreTreeData;
    }(),
    filterStoreNode: function filterStoreNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    convertStoreIdsToTreeKeys: function convertStoreIdsToTreeKeys(storeIds) {
      if (!storeIds || !Array.isArray(storeIds) || storeIds.length === 0) {
        return [];
      }
      var idMap = new Map();
      var _buildMap = function buildMap(nodes) {
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            _buildMap(node.children);
          } else if (node.storeId !== undefined) {
            idMap.set(node.storeId, node.id);
          }
        });
      };
      _buildMap(this.storeTreeData);
      return storeIds.map(function (storeId) {
        return idMap.get(storeId);
      }).filter(function (id) {
        return id !== undefined;
      });
    },
    openStoreSelector: function openStoreSelector() {
      var _this11 = this;
      this.storeSelectorVisible = true;
      this.$nextTick(function () {
        if (_this11.$refs.storeTreeDialog) {
          _this11.isStoreTreeInitializing = true;
          var treeKeys = _this11.convertStoreIdsToTreeKeys(_this11.storeCheckedKeys);
          _this11.$refs.storeTreeDialog.setCheckedKeys(treeKeys);
          _this11.$nextTick(function () {
            _this11.isStoreTreeInitializing = false;
          });
        }
      });
    },
    confirmStoreSelection: function confirmStoreSelection() {
      this.storeSelectorVisible = false;
    },
    removeStore: function removeStore(storeId) {
      this.storeCheckedKeys = this.storeCheckedKeys.filter(function (id) {
        return id !== storeId;
      });
      this.selectedStoreList = this.selectedStoreList.filter(function (store) {
        return store.id !== storeId;
      });
    },
    handleStoreCheckInDialog: function handleStoreCheckInDialog() {
      if (this.isStoreTreeInitializing) return;
      if (this.$refs.storeTreeDialog) {
        var checkedNodes = this.$refs.storeTreeDialog.getCheckedNodes(true);
        this.storeCheckedKeys = checkedNodes.map(function (node) {
          return node.storeId;
        });
        this.selectedStoreList = checkedNodes.map(function (node) {
          return {
            id: node.storeId,
            storeName: node.label,
            storeAddress: node.address || ''
          };
        });
      }
    },
    loadSelectedStoreInfo: function loadSelectedStoreInfo() {
      if (!this.storeCheckedKeys || this.storeCheckedKeys.length === 0) {
        this.selectedStoreList = [];
        return;
      }
      var _getAllLeafNodes = function getAllLeafNodes(nodes, checkedIds) {
        var leafNodes = [];
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            leafNodes = leafNodes.concat(_getAllLeafNodes(node.children, checkedIds));
          } else if (checkedIds.includes(node.storeId)) {
            leafNodes.push({
              id: node.storeId,
              storeName: node.label,
              storeAddress: node.address || ''
            });
          }
        });
        return leafNodes;
      };
      this.selectedStoreList = _getAllLeafNodes(this.storeTreeData, this.storeCheckedKeys);
    },
    selectAllStores: function selectAllStores() {
      var _this12 = this;
      this.isStoreTreeInitializing = true;
      var _getAllLeafKeys = function getAllLeafKeys(nodes) {
        var keys = {
          ids: [],
          storeIds: []
        };
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            var childKeys = _getAllLeafKeys(node.children);
            keys.ids = keys.ids.concat(childKeys.ids);
            keys.storeIds = keys.storeIds.concat(childKeys.storeIds);
          } else {
            keys.ids.push(node.id);
            keys.storeIds.push(node.storeId);
          }
        });
        return keys;
      };
      var allLeafKeys = _getAllLeafKeys(this.storeTreeData);
      if (this.isAllStoresSelected) {
        if (this.$refs.storeTreeDialog) {
          this.$refs.storeTreeDialog.setCheckedKeys([]);
        }
        this.storeCheckedKeys = [];
        this.selectedStoreList = [];
      } else {
        if (this.$refs.storeTreeDialog) {
          this.$refs.storeTreeDialog.setCheckedKeys(allLeafKeys.ids);
        }
        var _getAllLeafNodes2 = function getAllLeafNodes(nodes) {
          var leafNodes = [];
          nodes.forEach(function (node) {
            if (node.children && node.children.length > 0) {
              leafNodes = leafNodes.concat(_getAllLeafNodes2(node.children));
            } else {
              leafNodes.push({
                id: node.storeId,
                storeName: node.label,
                storeAddress: node.address || ''
              });
            }
          });
          return leafNodes;
        };
        this.storeCheckedKeys = allLeafKeys.storeIds;
        this.selectedStoreList = _getAllLeafNodes2(this.storeTreeData);
      }
      this.$nextTick(function () {
        _this12.isStoreTreeInitializing = false;
      });
    },
    handleReset: function handleReset() {
      var _this13 = this;
      this.$confirm('确认重置表单吗？所有未保存的内容将丢失。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this13.initFormData();
        _this13.dateRange = [];
        if (_this13.id) {
          _this13.loadFormData();
        }
        _this13.$message.success('已重置');
      }).catch(function () {});
    },
    loadUserRankList: function () {
      var _loadUserRankList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var response, _t9;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.prev = 0;
              _context1.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context1.sent;
              if (response.code === 200 && response.records) {
                this.userRankOptions = response.records.map(function (item) {
                  return {
                    id: item.id,
                    name: item.name
                  };
                });
              } else {
                console.error('获取用户级别列表失败:', response.message);
              }
              _context1.next = 3;
              break;
            case 2:
              _context1.prev = 2;
              _t9 = _context1["catch"](0);
              console.error('获取用户级别列表失败:', _t9);
            case 3:
            case "end":
              return _context1.stop();
          }
        }, _callee0, this, [[0, 2]]);
      }));
      function loadUserRankList() {
        return _loadUserRankList.apply(this, arguments);
      }
      return loadUserRankList;
    }(),
    handleSubmit: function handleSubmit() {
      var _this14 = this;
      this.$refs.couponForm.validate(function (valid) {
        if (!valid) {
          _this14.$message.error('请检查表单填写');
          return;
        }
        if (_this14.formData.sendType === 4 && !_this14.selectedPackageId) {
          _this14.$message.error('请选择券包');
          return;
        }
        if (_this14.formData.sendType === 1) {
          if (!_this14.selectedCouponId) {
            _this14.$message.error('请选择优惠券');
            return;
          }
          var checkedItems = _this14.selectedPackage && _this14.selectedPackage.items ? _this14.selectedPackage.items.filter(function (item) {
            return item.checked;
          }) : [];
          if (checkedItems.length === 0) {
            _this14.$message.error('请选择优惠券');
            return;
          }
        }
        if (!_this14.dateRange || _this14.dateRange.length !== 2) {
          _this14.$message.error('请选择活动时间');
          return;
        }
        _this14.submitLoading = true;
        try {
          var bonusJson = null;
          if (_this14.selectedPackage && _this14.selectedPackage.items) {
            var _checkedItems = _this14.selectedPackage.items.filter(function (item) {
              return item.checked;
            });
            var detailList = _checkedItems.map(function (item) {
              var timeStr = '';
              if (item.timeRange && Array.isArray(item.timeRange) && item.timeRange.length === 2) {
                timeStr = item.timeRange[0] + '-' + item.timeRange[1];
              }
              return {
                packageId: _this14.selectedPackage.id,
                id: item.id,
                crmCouponId: item.crmCouponId,
                couponAlias: item.couponAlias || '',
                couponTitle: item.couponTitle || '',
                couponType: item.couponType,
                sendNum: item.sendNum || 1,
                couponImgUrl: item.couponImgUrl || '',
                dailyInv: item.dailyInv || 0,
                totalNum: item.totalNum || 0,
                time: timeStr
              };
            });
            bonusJson = {
              id: _this14.selectedPackage.id,
              crmPackageId: _this14.selectedPackage.crmPackageId,
              packageName: _this14.selectedPackage.packageName,
              packageAlias: _this14.selectedPackage.packageAlias || '',
              packageDesc: _this14.selectedPackage.packageDesc || '',
              oldPrice: _this14.selectedPackage.oldPrice,
              price: _this14.selectedPackage.price,
              pkgImgUrl: _this14.selectedPackage.pkgImgUrl || '',
              detail: detailList
            };
          }
          var orderScenes = _this14.formData.orderScenes && _this14.formData.orderScenes.length > 0 ? _this14.formData.orderScenes : [1, 2, 3];
          var goodsIds = _this14.selectedGoodsList.map(function (item) {
            return item.goodsCode || item.id;
          });
          var categoryIds = _this14.selectedCategoryList;
          var storeIds = _this14.storeCheckedKeys || [];
          var finalUserType = _this14.formData.userType !== undefined ? _this14.formData.userType : 0;
          var finalIsQwe = _this14.formData.isQwe !== undefined ? _this14.formData.isQwe : 0;
          if (_this14.formData.event === 1) {
            finalUserType = 0;
            finalIsQwe = 0;
          }
          var safeJsonStringify = function safeJsonStringify(obj) {
            if (obj === null || obj === undefined) return '';
            try {
              var str = JSON.stringify(obj);
              JSON.parse(str);
              return str;
            } catch (e) {
              console.error('JSON序列化验证失败:', e, obj);
              if (Array.isArray(obj)) return '[]';
              if ((0, _typeof2.default)(obj) === 'object') return '{}';
              return '';
            }
          };
          var submitData = {
            id: _this14.formData.id || null,
            title: _this14.formData.title || '',
            sendType: _this14.formData.sendType || 1,
            event: _this14.formData.event || 1,
            userType: finalUserType,
            userRank: _this14.userRankList.join(','),
            isQwe: finalIsQwe,
            amount: _this14.formData.conditionConsume || 0,
            bonus: safeJsonStringify(bonusJson),
            startTime: _this14.formData.startTime,
            endTime: _this14.formData.endTime,
            enabled: _this14.formData.enabled !== undefined && _this14.formData.enabled !== null ? _this14.formData.enabled : 1,
            canShare: _this14.formData.canShare !== undefined && _this14.formData.canShare !== null ? _this14.formData.canShare : 0,
            sendNum: _this14.formData.sendNum || 0,
            theme: _this14.formData.event === 4 || _this14.formData.event === 3 ? safeJsonStringify(_this14.formData.theme) : '',
            rules: _this14.formData.rules || '',
            orderConsume: _this14.formData.orderConsume !== undefined ? _this14.formData.orderConsume : 0,
            goodsIds: safeJsonStringify(goodsIds),
            categoryIds: safeJsonStringify(categoryIds),
            orderScenes: safeJsonStringify(orderScenes),
            orderReal: _this14.formData.orderReal !== undefined ? _this14.formData.orderReal : 1,
            storeIds: safeJsonStringify(storeIds),
            consumeMaxTimes: _this14.formData.consumeMaxTimes || 1,
            daily: _this14.formData.daily || 0
          };
          (0, _bonusSend.saveBonusSend)(submitData).then(function (response) {
            if (response.code === 200) {
              _this14.$message.success(_this14.id ? '编辑成功' : '添加成功');
              _this14.$emit('success');
            } else {
              _this14.$message.error(response.message || '保存失败');
            }
          }).catch(function (error) {
            _this14.$message.error('保存失败：' + error.message);
          }).finally(function () {
            _this14.submitLoading = false;
          });
        } catch (error) {
          _this14.$message.error('保存失败：' + error.message);
          _this14.submitLoading = false;
        }
      });
    }
  }
};